class ReudynMilestones extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.points = [...this.querySelectorAll('[data-milestone]')];
    this.panels = [...this.querySelectorAll('[data-milestone-panel]')];
    this.rail = this.querySelector('[data-milestone-rail]');
    this.viewport = this.querySelector('[data-milestone-viewport]');
    this.track = this.querySelector('.reudyn-about-milestones__track');
    this.index = Math.max(0, this.points.findIndex((point) => point.hasAttribute('data-active')));
    this.swiped = false;
    this.points.forEach((point) => {
      point.addEventListener('click', (event) => {
        if (this.swiped) {
          event.preventDefault();
          this.swiped = false;
          return;
        }
        this.show(point.dataset.milestone);
      });
    });
    this.bindMobileSwipe(this.viewport);
    this.bindMobileSwipe(this.track);
    this.onResize = () => this.slide(false);
    window.addEventListener('resize', this.onResize, { passive: true });
    this.slide(false);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  bindMobileSwipe(area) {
    if (!area || this.points.length < 2) return;
    let x0 = 0;
    let y0 = 0;
    let active = false;

    area.addEventListener(
      'pointerdown',
      (event) => {
        if (!this.isMobile()) return;
        active = true;
        this.swiped = false;
        x0 = event.clientX;
        y0 = event.clientY;
      },
      { passive: true }
    );

    area.addEventListener(
      'pointermove',
      (event) => {
        if (!active || !this.isMobile()) return;
        const dx = event.clientX - x0;
        const dy = event.clientY - y0;
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) {
          this.swiped = true;
        }
      },
      { passive: true }
    );

    const end = (event) => {
      if (!active) return;
      active = false;
      if (!this.isMobile()) return;
      const dx = event.clientX - x0;
      const dy = event.clientY - y0;
      if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy)) return;
      this.swiped = true;
      this.go(dx < 0 ? 1 : -1);
    };

    area.addEventListener('pointerup', end, { passive: true });
    area.addEventListener('pointercancel', () => {
      active = false;
    }, { passive: true });
  }

  go(step) {
    if (this.points.length < 2) return;
    const next = Math.min(this.points.length - 1, Math.max(0, this.index + step));
    if (next === this.index) return;
    this.show(this.points[next].dataset.milestone);
  }

  show(id) {
    const index = this.points.findIndex((point) => point.dataset.milestone === id);
    if (index < 0 || index === this.index) return;
    this.index = index;
    this.points.forEach((point, i) => {
      const on = i === index;
      point.toggleAttribute('data-active', on);
      point.setAttribute('aria-current', on ? 'true' : 'false');
    });
    this.panels.forEach((panel, i) => panel.toggleAttribute('data-active', i === index));
    this.slide(true);
  }

  slide(animate) {
    if (!this.rail || !this.viewport) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.rail.style.transition = animate && !reduce ? '' : 'none';
    this.rail.style.transform = `translateX(${-this.index * this.viewport.clientWidth}px)`;
    if (!animate || reduce) {
      requestAnimationFrame(() => {
        if (this.rail) this.rail.style.transition = '';
      });
    }
  }
}

if (!customElements.get('reudyn-milestones')) {
  customElements.define('reudyn-milestones', ReudynMilestones);
}
